import {baseUrl} from'../config';

export const notificationController ={
    getAllNotifications:baseUrl+'/api/notification',
} 